import { eTienThuaHocSinhActionTypeDefine } from "../../action-types/category/ITienThuaHocSinhActionType";
import { generateActions } from "../generateActions";

export const tienThuaHocSinhActions = {
    ...generateActions(eTienThuaHocSinhActionTypeDefine, "TIEN_THUA_HOC_SINH"),
    
}
